module.exports = __webpack_public_path__ + "media/backMusic.02e00883.wav";